import { Check, DollarSign, Sparkles, Star, Trophy } from 'lucide-react';

const money = (value) => `$${Number(value || 0).toLocaleString()}`;

export function DebtClearedCelebration({ celebration, busy, reducedMotion, onContinue }) {
  if (!celebration?.pending) return null;
  return (
    <div className={`debt-celebration-overlay ${reducedMotion ? 'reduced-motion' : ''}`} role="dialog" aria-modal="true" aria-labelledby="debt-cleared-title">
      <section className="debt-celebration-card">
        <div className="debt-paid-stamp" aria-hidden="true"><Check />PAID</div>
        <div className="debt-celebration-sparks" aria-hidden="true"><Sparkles /><DollarSign /><Star /></div>
        <span className="debt-celebration-kicker">LONG HAUL MILESTONE</span>
        <h2 id="debt-cleared-title">{celebration.title || 'THE DEBT IS DEAD'}</h2>
        <p className="debt-celebration-lead">You beat the deadline on Day {celebration.day}.</p>
        <p>{celebration.message || 'The loan shark is off your back. Long Haul is officially unlocked.'}</p>
        <div className="debt-celebration-stats">
          <div><span>Debt</span><strong>$0</strong></div>
          <div><span>Days remaining</span><strong>{celebration.daysRemaining ?? 0}</strong></div>
          <div><span>Cash</span><strong>{money(celebration.cash)}</strong></div>
          <div><span>Street rep</span><strong>{celebration.streetReputation ?? 0}</strong></div>
        </div>
        <div className="debt-unlocked"><Trophy /><span><strong>LONG HAUL UNLOCKED</strong><small>Keep hustling, build the bankroll, and see what survives to day 120.</small></span></div>
        <button className="debt-celebration-action" onClick={onContinue} disabled={busy}>{busy ? 'SAVING MILESTONE…' : 'KEEP HUSTLING'}</button>
      </section>
    </div>
  );
}
